import type { EffectiveLoyaltyProgram } from '@/lib/api/loyalty';

const applyRounding = (value: number, mode: EffectiveLoyaltyProgram['roundingMode']): number => {
  switch (mode) {
    case 'ceil':
      return Math.ceil(value);
    case 'nearest':
      return Math.round(value);
    case 'floor':
    default:
      return Math.floor(value);
  }
};

export const computeProjectedLoyaltyPoints = (
  program: EffectiveLoyaltyProgram | null | undefined,
  subtotalCents: number,
): number => {
  if (!program || program.status !== 'enabled') {
    return 0;
  }

  if (!Number.isFinite(subtotalCents) || subtotalCents <= 0) {
    return 0;
  }

  const safePointsPerCurrency =
    typeof program.pointsPerCurrency === 'number' && Number.isFinite(program.pointsPerCurrency)
      ? Math.max(0, program.pointsPerCurrency)
      : 0;
  const safeCurrencyUnit =
    typeof program.currencyUnit === 'number' && Number.isFinite(program.currencyUnit) && program.currencyUnit > 0
      ? Math.round(program.currencyUnit)
      : 100;
  const safePointsPerOrder =
    typeof program.pointsPerOrder === 'number' && Number.isFinite(program.pointsPerOrder)
      ? Math.max(0, Math.round(program.pointsPerOrder))
      : 0;

  let points = 0;

  if (program.earnMode === 'per_spend' || program.earnMode === 'hybrid') {
    const raw = (subtotalCents / safeCurrencyUnit) * safePointsPerCurrency;
    points += applyRounding(raw, program.roundingMode);
  }

  if (program.earnMode === 'per_order' || program.earnMode === 'hybrid') {
    points += safePointsPerOrder;
  }

  if (!Number.isFinite(points) || points <= 0) {
    return 0;
  }

  return Math.max(0, Math.floor(points));
};

export { applyRounding as applyLoyaltyRounding };
